import { Component,OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'app-age-group',
    templateUrl: './age-group.component.html',
    styleUrl: './age-group.component.scss',
    standalone: false
})
export class AgeGroupComponent implements OnInit {
  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  
   ngOnInit(){
    this.dynamicStyleLoader.focusCloseButton('mob-focus-gender', 'desktop-focus-gender');     
  }
  
}
